(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const S = window.themeStrings || {};
  const money = (cents) => {
    const tr = (S.locale || 'tr') === 'tr';
    const n = new Intl.NumberFormat(tr ? 'tr-TR' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    return `${n} TL`;
  };

  /* ---------- Hero slider ---------- */
  function initHero(el) {
    const track = $('[data-track]', el);
    if (!track || el.dataset.ready) return;
    el.dataset.ready = 1;
    const slides = track.children;
    const dots = $$('[data-dots] button', el);
    let i = 0, timer;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const auto = () => {
      clearInterval(timer);
      const s = parseInt(el.dataset.autoplay, 10);
      if (s > 0 && slides.length > 1) timer = setInterval(() => go(i + 1), s * 1000);
    };
    $('[data-prev]', el)?.addEventListener('click', () => { go(i - 1); auto(); });
    $('[data-next]', el)?.addEventListener('click', () => { go(i + 1); auto(); });
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); auto(); }));
    let x0 = null;
    track.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); auto(); }
      x0 = null;
    });
    auto();
  }

  /* ---------- Carousels ---------- */
  function initCarousel(el) {
    const track = $('[data-track]', el);
    if (!track || el.dataset.ready) return;
    el.dataset.ready = 1;
    const prev = $('[data-prev]', el), next = $('[data-next]', el);
    const step = () => {
      const item = track.children[0];
      return item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
    };
    const update = () => {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step() }));
    next?.addEventListener('click', () => track.scrollBy({ left: step() }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Tabs ---------- */
  function initTabs(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = 1;
    const btns = $$('[data-tab]', el);
    btns.forEach((b) => b.addEventListener('click', () => {
      btns.forEach((x) => x.classList.toggle('is-active', x === b));
      $$('[data-panel]', el).forEach((p) => {
        p.hidden = p.dataset.panel !== b.dataset.tab;
        if (!p.hidden) $$('[data-carousel]', p).forEach((c) => c.querySelector('[data-track]').dispatchEvent(new Event('scroll')));
      });
    }));
  }

  /* ---------- Mobile nav & announcement ---------- */
  function initNav() {
    const nav = $('[data-nav]');
    const overlay = $('.nav-overlay');
    if (!nav) return;
    const toggle = (open) => {
      nav.classList.toggle('is-open', open);
      overlay?.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    $$('[data-open-nav]').forEach((b) => b.addEventListener('click', () => toggle(true)));
    $$('[data-close-nav]').forEach((b) => b.addEventListener('click', () => toggle(false)));
    $$('.nav__toggle', nav).forEach((b) => b.addEventListener('click', () => b.parentElement.classList.toggle('is-open')));
  }
  function initAnnounce() {
    const items = $$('.announce__item');
    if (items.length < 2) return;
    let i = 0;
    items[0].classList.add('is-active');
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3500);
  }

  /* ---------- Wishlist (localStorage) ---------- */
  const WKEY = 'bale-wishlist';
  const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } };
  const writeWish = (v) => { try { localStorage.setItem(WKEY, JSON.stringify(v)); } catch (e) { /* storage blocked */ } };
  function paintWish() {
    const list = readWish();
    $$('[data-wish]').forEach((b) => b.classList.toggle('is-on', list.includes(b.dataset.wish)));
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    let list = readWish();
    const h = b.dataset.wish;
    list = list.includes(h) ? list.filter((x) => x !== h) : [...list, h];
    writeWish(list);
    paintWish();
  });
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-wishlist-link]');
    if (!a) return;
    e.preventDefault();
    const list = readWish();
    if (!list.length) return toast(S.wishlistEmpty);
    window.location.href = `${root}search?q=${encodeURIComponent(list.map((h) => `handle:${h}`).join(' OR '))}&type=product`;
  });

  /* ---------- Toast ---------- */
  function toast(msg) {
    const t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 2600);
  }

  /* ---------- Cart drawer ---------- */
  const drawer = () => $('#CartDrawer');
  function openCart() {
    const d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  async function refreshCart() {
    const cart = await fetch(`${root}cart.js`).then((r) => r.json());
    $$('[data-cart-count]').forEach((c) => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0 && c.classList.contains('cart-btn__count'); });
    $$('[data-cart-total]').forEach((c) => { c.textContent = money(cart.total_price); });
    const co = $('[data-checkout]');
    if (co) co.hidden = cart.item_count === 0;
    const body = $('[data-cart-body]');
    if (body) body.innerHTML = renderLines(cart);
  }
  function renderLines(cart) {
    if (!cart.items.length) return `<p class="drawer__empty">${S.cartEmpty}</p>`;
    return cart.items.map((it) => `
      <div class="line">
        <a href="${it.url}" class="line__img">${it.image ? `<img src="${it.image}&width=160" alt="" loading="lazy">` : ''}</a>
        <div class="line__info">
          <div class="card__vendor">${it.vendor || ''}</div>
          <a href="${it.url}" class="line__title">${it.product_title}</a>
          ${it.product_has_only_default_variant ? '' : `<div class="line__variant">${it.variant_title || ''}</div>`}
          <div class="line__row">
            <div class="qty qty--sm" data-line-key="${it.key}">
              <button type="button" data-qty-change="-1" aria-label="-">−</button>
              <input type="number" value="${it.quantity}" min="0" aria-label="${S.quantity}">
              <button type="button" data-qty-change="1" aria-label="+">+</button>
            </div>
            <strong>${money(it.final_line_price)}</strong>
          </div>
        </div>
      </div>`).join('');
  }
  async function changeLine(key, qty) {
    await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
    await refreshCart();
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-close-drawer]')) { closeCart(); return; }
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      const wrap = q.closest('[data-line-key]');
      const input = $('input', wrap);
      const v = Math.max(0, parseInt(input.value, 10) + parseInt(q.dataset.qtyChange, 10));
      input.value = v;
      changeLine(wrap.dataset.lineKey, v);
    }
    const s = e.target.closest('[data-qty-step]');
    if (s) {
      const input = $('input', s.parentElement);
      input.value = Math.max(1, parseInt(input.value, 10) + parseInt(s.dataset.qtyStep, 10));
    }
  });
  document.addEventListener('change', (e) => {
    const wrap = e.target.closest('[data-line-key]');
    if (wrap && e.target.matches('input')) changeLine(wrap.dataset.lineKey, Math.max(0, parseInt(e.target.value, 10) || 0));
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  /* ---------- Product form ---------- */
  function initProduct(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = 1;
    const variants = JSON.parse($('[data-variants]', el)?.textContent || '[]');
    const stockMap = JSON.parse($('[data-stock-map]', el)?.textContent || '{}');
    const form = $('[data-product-form]', el);
    const idInput = $('[data-variant-id]', el);
    const addBtn = $('[data-add]', el);
    const priceBox = $('[data-price]', el);
    const stock = $('[data-stock]', el);

    // Gallery: all images open in a grid (reference). Colour filter: alt "<colour> | ...".
    const items = $$('[data-media-color]', el).filter((i) => i.classList.contains('pdp__item'));
    const list = $('[data-media-list]', el);
    const filterByColour = (colour) => {
      const has = colour && items.some((i) => i.dataset.mediaColor === colour);
      items.forEach((i) => { i.hidden = has && i.dataset.mediaColor !== colour && i.dataset.mediaColor !== ''; });
      if (list) {
        list.classList.toggle('pdp__media--single', items.filter((i) => !i.hidden).length < 2);
        list.scrollLeft = 0;
      }
    };
    // Lightbox: click an image to open it large; click again to zoom, arrows/swipe to browse.
    const lb = $('[data-lightbox]', el);
    if (lb) {
      const img = $('[data-lb-img]', lb), stage = $('[data-lb-stage]', lb), count = $('[data-lb-count]', lb);
      let pool = [], idx = 0, sx = null;
      const show = (n) => {
        idx = (n + pool.length) % pool.length;
        stage.classList.remove('is-zoom'); img.style.transformOrigin = '';
        img.src = pool[idx].dataset.zoom;
        img.alt = $('img', pool[idx])?.alt || '';
        count.textContent = pool.length > 1 ? `${idx + 1} / ${pool.length}` : '';
        lb.classList.toggle('lb--single', pool.length < 2);
      };
      const close = () => { lb.hidden = true; document.documentElement.classList.remove('lb-open'); };
      items.forEach((it) => {
        if (!it.dataset.zoom) return;
        it.classList.add('is-zoomable');
        it.addEventListener('click', () => {
          pool = items.filter((i) => !i.hidden && i.dataset.zoom);
          lb.hidden = false; document.documentElement.classList.add('lb-open');
          show(pool.indexOf(it));
        });
      });
      $('[data-lb-close]', lb).addEventListener('click', close);
      $('[data-lb-prev]', lb).addEventListener('click', () => show(idx - 1));
      $('[data-lb-next]', lb).addEventListener('click', () => show(idx + 1));
      lb.addEventListener('click', (e) => { if (e.target === lb || e.target === stage) close(); });
      const pan = (x, y) => {
        const r = img.getBoundingClientRect();
        img.style.transformOrigin = `${((x - r.left) / r.width) * 100}% ${((y - r.top) / r.height) * 100}%`;
      };
      img.addEventListener('click', (e) => {
        if (!stage.classList.contains('is-zoom')) pan(e.clientX, e.clientY);
        stage.classList.toggle('is-zoom');
      });
      img.addEventListener('mousemove', (e) => { if (stage.classList.contains('is-zoom')) pan(e.clientX, e.clientY); });
      stage.addEventListener('touchstart', (e) => { sx = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
      stage.addEventListener('touchmove', (e) => {
        if (stage.classList.contains('is-zoom') && e.touches.length === 1) { e.preventDefault(); pan(e.touches[0].clientX, e.touches[0].clientY); }
      }, { passive: false });
      stage.addEventListener('touchend', (e) => {
        if (sx === null || stage.classList.contains('is-zoom') || pool.length < 2) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
        sx = null;
      });
      document.addEventListener('keydown', (e) => {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(idx - 1);
        else if (e.key === 'ArrowRight') show(idx + 1);
      });
    }

    const colourIndex = $$('.opt', el).findIndex((f) => $('.opt__values--swatch', f));

    const selected = () => $$('.opt', el).map((f) => $('input:checked', f)?.value);
    if (colourIndex > -1) filterByColour(selected()[colourIndex]);
    const update = () => {
      const opts = selected();
      const v = variants.find((x) => x.options.every((o, k) => o === opts[k]));
      $$('.opt', el).forEach((f, k) => {
        const lab = $('[data-option-value]', f);
        if (lab) lab.textContent = `(${opts[k]})`;
        $$('.opt__value', f).forEach((l) => {
          const val = $('input', l).value;
          const test = opts.slice(); test[k] = val;
          const ok = variants.some((x) => x.available && x.options.every((o, j) => o === test[j]));
          l.classList.toggle('is-unavailable', !ok);
        });
      });
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = S.unavailable;
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? S.addToCart : S.soldOut;
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      priceBox.innerHTML = `<div class="price${sale ? ' price--sale' : ''}">${sale ? `<s class="price__compare">${money(v.compare_at_price)}</s>` : ''}<span class="price__current">${money(v.price)}</span></div>`;
      if (stock) {
        const st = stockMap[v.id] || (v.available ? 'ok' : 'no');
        const map = { ok: ['ok', S.inStock], low: ['warn', S.lowStock], no: ['no', S.soldOut] };
        stock.innerHTML = `<span class="dot dot--${map[st][0]}"></span><strong>${map[st][1]}</strong>`;
      }
      const vl = $('[data-variant-label]', el);
      if (vl) vl.textContent = $$('.opt', el).map((f, k) => `${$('.opt__label', f).firstChild.textContent.trim()} ${v.options[k]}`).join(', ');
      if (colourIndex > -1) filterByColour(v.options[colourIndex]);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    };
    $$('.opt input', el).forEach((i) => i.addEventListener('change', update));
    if ($$('.opt', el).length) update();

    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      addBtn.disabled = true;
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      addBtn.disabled = false;
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        toast(err.description || S.addError);
        return;
      }
      await refreshCart();
      openCart();
    });
  }

  /* ---------- Related products ---------- */
  function initRelated(el) {
    if (el.dataset.ready || el.children.length) return;
    el.dataset.ready = 1;
    fetch(el.dataset.url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-related]');
      if (inner && inner.innerHTML.trim()) {
        el.innerHTML = inner.innerHTML;
        $$('[data-carousel]', el).forEach(initCarousel);
        paintWish();
      }
    }).catch(() => {});
  }

  /* ---------- Cookie consent (KVKK) ---------- */
  function initCookies() {
    const box = $('#CookieBanner');
    if (!box) return;
    const KEY = 'ritmist-consent';
    const prefs = $('[data-cookie-prefs]', box);
    const save = $('[data-cookie-save]', box);
    const toggle = $('[data-cookie-toggle]', box);
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } };
    const apply = (c) => {
      const send = () => {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(
            { analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing },
            () => {}
          );
        } catch (e) { /* API unavailable */ }
      };
      if (window.Shopify && Shopify.customerPrivacy) send();
      else if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) send(); });
    };
    const store = (c) => {
      try { localStorage.setItem(KEY, JSON.stringify({ ...c, at: Date.now() })); } catch (e) { /* storage blocked */ }
      apply(c);
      box.hidden = true;
    };
    const open = (withPrefs) => {
      const c = read() || {};
      $$('[data-consent]', box).forEach((i) => { i.checked = !!c[i.dataset.consent]; });
      prefs.hidden = !withPrefs;
      save.hidden = !withPrefs;
      toggle.hidden = withPrefs;
      box.hidden = false;
    };
    toggle.addEventListener('click', () => open(true));
    $('[data-cookie-all]', box).addEventListener('click', () => store({ analytics: true, marketing: true, preferences: true }));
    $('[data-cookie-necessary]', box).addEventListener('click', () => store({ analytics: false, marketing: false, preferences: false }));
    save.addEventListener('click', () => {
      const c = {};
      $$('[data-consent]', box).forEach((i) => { c[i.dataset.consent] = i.checked; });
      store(c);
    });
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href*="#cerez-ayarlari"], a[href*="#cookie-settings"], [data-cookie-settings]');
      if (!a) return;
      e.preventDefault();
      open(true);
    });
    const saved = read();
    if (saved) apply(saved);
    else open(false);
  }

  function init(scope = document) {
    $$('[data-slider]', scope).forEach(initHero);
    $$('[data-carousel]', scope).forEach(initCarousel);
    $$('[data-tabs]', scope).forEach(initTabs);
    $$('[data-product]', scope).forEach(initProduct);
    $$('[data-related]', scope).forEach(initRelated);
    paintWish();
  }

// rt-mobil-arama
  const initSearch = () => {
    const header = document.querySelector('[data-header]');
    const form = document.querySelector('[data-psearch-form]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]'), box = form.querySelector('[data-psearch]');
    const en = (document.documentElement.lang || '').startsWith('en');
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    document.querySelectorAll('[data-search-toggle]').forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault();
      const open = header.classList.toggle('is-search-open');
      if (open) { input.focus(); } else { box.hidden = true; }
    }));
    document.addEventListener('click', (e) => {
      if (form.contains(e.target) || e.target.closest('[data-search-toggle]')) return;
      box.hidden = true; header && header.classList.remove('is-search-open');
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { box.hidden = true; header && header.classList.remove('is-search-open'); } });
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const tl = (p) => Number(p).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
    let timer, last = '';
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(async () => {
        last = q;
        try {
          const r = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][prefix]=last`);
          const d = await r.json();
          if (q !== last) return;
          const ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          const all = `${root}search?q=${encodeURIComponent(q)}&options[prefix]=last`;
          box.innerHTML = ps.length
            ? ps.map((p) => `<a href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image + (p.image.includes('?') ? '&' : '?') + 'width=100')}" alt="" loading="lazy">` : '<img alt="">'}<span class="psearch__t">${esc(p.title)}</span><span class="psearch__p">${tl(p.price)}</span></a>`).join('')
              + `<a class="psearch__all" href="${all}">${en ? 'See all results' : 'Tüm sonuçları gör'}</a>`
            : `<div class="psearch__none">${en ? 'No results for' : 'Sonuç bulunamadı:'} “${esc(q)}”</div>`;
          box.hidden = false;
        } catch (e) { box.hidden = true; }
      }, 250);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initSearch();
    init();
    initNav();
    initAnnounce();
    initCookies();
  });
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
